var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('topheader',{attrs:{"back":"back"}}),_c('maincontent',{scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('setpassword')]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }